export default (context:any, payload:any) => {
    const moduleId = context.getters.moduleId;
    const targetId = `${moduleId}_table`;

    const items = context.getters.tableData;

    const setAttribute = payload.oneLni.storeUtils.setAttribute;
    // Update lni-table properties
    setAttribute(context, targetId, 'items', items);
    setAttribute(context, targetId, 'totalItems', context.getters.tableData.length);
    setAttribute(context, targetId, 'loadState', 'loaded');

    if (context.rootState[moduleId].editable) {
        setTimeout(() => {
            items.forEach((item:any, index:number) => {
                context.commit('setAttribute', {
                    id: `${targetId}--assignment-${index}`,
                    attribute: 'htmlString',
                    value: item.assignment,
                }, {
                    root: true,
                });
                context.commit('setAttribute', {
                    id: `${targetId}--action-${index}`,
                    attribute: 'htmlString',
                    value: item.action,
                }, {
                    root: true,
                });
            });
        });
    }
};